import React from "react";
import { Box, Skeleton } from "@mui/material";

const TravelStyleCardSkeleton: React.FC = () => (
  <Box
    sx={{
      width: "100%",
      maxWidth: { xs: "100%", sm: "400px" },
      boxShadow: 6,
      backgroundColor: "background.default"
    }}
    data-testid="travel-style-card-skeleton"
  >
    {/* Image Skeleton */}
    <Skeleton
      variant="rectangular"
      sx={{
        width: "100%",
        height: { xs: 180, sm: 218 },
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px"
      }}
    />

    {/* Content Skeleton */}
    <Box
      sx={{
        padding: "20px",
        border: "1px solid",
        borderColor: "divider",
        borderTop: "none",
        borderBottomLeftRadius: "20px",
        borderBottomRightRadius: "20px",
        backgroundColor: "background.default"
      }}
    >
      {/* Title */}
      <Skeleton variant="text" sx={{ fontSize: "20px", width: "70%", mb: 1 }} />
      {/* Description */}
      <Skeleton variant="text" sx={{ fontSize: "18px", width: "100%" }} />
      <Skeleton variant="text" sx={{ fontSize: "18px", width: "90%" }} />
      <Skeleton variant="text" sx={{ fontSize: "18px", width: "60%", mb: 2 }} />
      {/* Button */}
      <Skeleton
        variant="rectangular"
        sx={{ width: 150, height: 40, borderRadius: "100px" }}
      />
    </Box>
  </Box>
);

interface TravelStyleSectionSkeletonProps {
  cardCount?: number;
}

const TravelStyleSectionSkeleton: React.FC<TravelStyleSectionSkeletonProps> = ({
  cardCount = 5
}) => (
  <Box
    component="section"
    data-testid="travel-style-section-skeleton"
    sx={{
      padding: "40px 24px",
      "@media (min-width: 1020px)": {
        padding: "40px 100px"
      },
      backgroundColor: "background.default"
    }}
  >
    {/* Header Skeleton */}
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: "40px" }}>
      <Skeleton variant="text" sx={{ fontSize: "32px", width: 300 }} />
      <Skeleton variant="text" sx={{ fontSize: "18px", width: 400, mt: 2 }} />
    </Box>

    {/* Cards Layout Skeleton */}
    <Box
      sx={{
        maxWidth: "1240px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "20px"
      }}
    >
      {Array.from({ length: cardCount }).map((_, index) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          sx={{
            width: { xs: "100%", sm: "400px" },
            maxWidth: "400px",
            flex: { xs: "1 1 100%", sm: "0 0 400px" },
            display: "flex",
            justifyContent: "center"
          }}
        >
          <TravelStyleCardSkeleton />
        </Box>
      ))}
    </Box>
  </Box>
);

export default TravelStyleSectionSkeleton;
export { TravelStyleCardSkeleton };
